<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <v-card>
      <v-card-title>
        {{ data?.status === "APPROVED" ? "Aprovar" : "Reprovar" }} solicitação
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle> Tipo de benefício </v-list-item-subtitle>
              <v-list-item-title>
                {{ definitions.types[concessionRequest.type].name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle> Válidade </v-list-item-subtitle>
              <v-list-item-title>
                {{ !data?.expiresAt ? "Vitalício" : "Expira em" }}
                {{ data?.expiresAt | date }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-textarea
          v-if="data?.status === 'REJECTED'"
          v-model="reason"
          label="Motivo"
          placeholder="Digite o motivo da reprovação"
          outlined
          rows="3"
          class="mt-2"
          :disabled="loading"
        ></v-textarea>

        <v-alert v-if="error" type="error">
          {{ error }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="close" :disabled="loading">Cancelar</v-btn>
        <v-spacer />
        <v-btn
          :color="data?.status === 'APPROVED' ? 'success' : 'error'"
          @click="resolve"
          depressed
          :loading="loading"
          :disabled="data?.status === 'REJECTED' && !reason"
        >
          {{ data?.status === "APPROVED" ? "Aprovar" : "Reprovar" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import definitions from "@/definitions/ConcessionRequest.json";
import CONCESSION_REQUEST from "@/services/admin/concessionRequest";

export default {
  name: "ConcessionResolveModal",
  props: {
    concessionRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      definitions,
      dialog: false,
      error: null,
      loading: false,
      data: null,
      reason: null,
    };
  },
  methods: {
    open(data) {
      this.loading = false;
      this.error = null;
      this.data = data;
      this.reason = null;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.loading = false;
      this.error = null;
      this.data = null;
      this.reason = null;
    },
    async resolve() {
      try {
        this.loading = true;
        this.error = null;

        await CONCESSION_REQUEST.resolveRequest(this.concessionRequest.id, {
          status: this.data?.status,
          expiresAt: this.data?.expiresAt,
          reason: this.reason,
        });
        this.$emit("success");
      } catch (error) {
        this.error =
          error.message || "Erro ao buscar solicitação de meia entrada";
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("company", ["selectedOrganization"]),
  },
  mounted() {
    this.$parent.$on("resolveConcessionRequest", this.open);
  },
};
</script>
